import { Select } from 'client/components/core/Sidebar/components/Settings/components'
import { SettingsProps } from 'client/components/core/Sidebar/components/Settings/entities'
import { useUpdateProp } from 'client/components/core/Sidebar/components/Settings/hooks/useUpdateProps'
import {
  ButtonActionTypeEnum,
  buttonActionsNames,
} from 'common/enums/ButtonActionTypeEnum'
import React, { useEffect } from 'react'
import { WebsiteButtonEntityInterface } from 'src/shared/entities/website-button/website-button.schema'
import { ButtonDownloadFileActionSettings } from '../../../settings/button/button-download-file-action-settings'
import { ButtonOpenUrlActionSettings } from '../../../settings/button/button-open-url-action-settings'
import { ButtonShowPopupActionSettings } from '../../../settings/button/button-show-popup-action-settings'
import { WebsiteButtonWebsiteLinkActionSettings } from './website-button-website-link-action-settings'

const pageButtonActions = [
  ButtonActionTypeEnum.OpenUrl,
  ButtonActionTypeEnum.WebsitePageLink,
  ButtonActionTypeEnum.ShowPopup,
  ButtonActionTypeEnum.DownloadFile,
] as const

export const WebsiteButtonActionsSettings = ({
  entity,
}: SettingsProps<WebsiteButtonEntityInterface>) => {
  const updateProp = useUpdateProp(entity)

  const availableButtonActions = pageButtonActions.reduce(
    (actions, action) => {
      if (buttonActionsNames[action]) {
        actions[action] = buttonActionsNames[action]
      }
      return actions
    },
    {} as Record<ButtonActionTypeEnum, string>,
  )
  useEffect(() => {
    if (entity.action && !pageButtonActions.includes(entity.action)) {
      updateProp('action')(pageButtonActions[0])
    }
  }, [entity.action])

  return (
    <>
      {!!pageButtonActions.length && (
        <Select
          update={updateProp('action')}
          choiceList={availableButtonActions}
          labelText="entity_settings.button.action_label"
          value={entity.action}
        />
      )}
      <ButtonDownloadFileActionSettings entity={entity} />
      <ButtonOpenUrlActionSettings entity={entity} />
      <WebsiteButtonWebsiteLinkActionSettings entity={entity} />
      <ButtonShowPopupActionSettings entity={entity} />
    </>
  )
}
